import { Component, OnInit, Input, ChangeDetectorRef, HostListener } from '@angular/core';
import { Utilities } from '../../utilities';
import { Router } from '@angular/router';
import { Banner } from '../../models/Banner';
import { BannerService } from './banner.service';
import { TCCPLocalStorageService } from '../../services/tccp-local-storage.service';
import { environment } from '../../../../environments/environment';
import { MatTooltip } from '@angular/material/tooltip';
import { TCCPCommonService } from '../../services/tccp-common.service';

@Component({
  selector: 'app-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss']
})
export class BannerComponent implements OnInit {
  @Input() bannerId: string = null;
  public isToyota: boolean;
  public isInternal = false;
  public urlPath = Utilities.GetLastPath(this.router.url);
  public arrowIcon = 'close_fullscreen';
  public showShortDescription = false;
  public appName = '';
  public banner: Banner = <Banner>{};
  public bannerContentWidth: number;
  public tip = 'maximize banner';
  public showAlertIcon = false;
  public isSingleLine = false;
  public isCloseClicked: boolean;
  public windowWidth: number = window.innerWidth;

  constructor(public router: Router,
    public bannerService: BannerService,
    public storageService: TCCPLocalStorageService, private commonService: TCCPCommonService,
    public cdRef: ChangeDetectorRef) { }

  ngOnInit() {
    this.isCloseClicked = this.storageService.getBannerCloseStatus();
    if (this.bannerId === undefined) {
      this.isToyota = Utilities.GetPath(this.router.url) === 'toyota' ? true : false;
    } else {
      this.isToyota = environment.applicationName === 'toyota';
    }
    this.appName = this.bannerId ? environment.applicationName : this.isToyota ? 'toyota' : 'lexus';
    this.storageService.setAppName(this.appName);
    this.isInternal = this.commonService.setAppFeatureType(this.router.url);
    this.arrowIcon = this.showShortDescription ? 'open_in_full' : 'close_fullscreen';
    if (this.bannerId === undefined) {
      this.getBanner();
    } else {
      this.getBanner(this.bannerId);
    }
    this.windowWidth = window.innerWidth;
  }

  getWidth() {
    const textEle = document.getElementById('banner-text');
    textEle.innerHTML = this.banner.content;
    textEle.style.fontSize = '15px';
    textEle.style.whiteSpace = this.showShortDescription ? 'nowrap' : 'normal';
    textEle.style.overflowX = 'visible';
    this.bannerContentWidth = -textEle.offsetWidth;
    const scrBan = document.querySelector<HTMLElement>('.banner-content');
    scrBan.style.setProperty('--scrolling-width', this.bannerContentWidth + 'px');
    const scrolltime = this.windowWidth > textEle.offsetWidth ? (this.windowWidth * 2.5) / 100 : (textEle.offsetWidth * 2.5) / 100;
    scrBan.style.setProperty('--scrolling-time', (scrolltime) + 's');
  }

  hideTooltipIn(tooltip: MatTooltip, ms: number) {
    this.tip = this.showShortDescription ? 'maximize banner' : 'minimize banner';
    tooltip.toggle();
    setTimeout(() => tooltip.hide(), ms);
  }


  showBanner(bannerId?): boolean {
    let show = false;
    if (bannerId) {
      show = true;
    } else {
      if ((this.isInternal && this.banner.content !== undefined && this.banner.contentType !== 'External') ||
        (!this.isInternal && this.banner.content !== undefined && this.banner.contentType !== 'Internal')) {
        if (!show) {
          show = true;
          return show;
        }
      }
      show = false;
    }
    return show;
  }

  getBanner(bannerId?: string) {
    const status = 'Publish';
    this.bannerService.getBanner(this.appName, status, bannerId).subscribe(response => {
      if (response) {
        if (!bannerId || bannerId === undefined) {
          const banner = this.isInternal ? response.filter(x => x.contentType === 'Internal' || x.contentType === 'Both')
            : response.filter(x => x.contentType === 'External' || x.contentType === 'Both');
          this.banner = banner && banner.length > 0 ? banner[0] : <Banner>{};
          // alert(this.banner.content);
          // Hide/Show the banner based on the banner
          const hideBannerInfo = banner && banner.length === 0;
          this.commonService.hideBanner.emit(hideBannerInfo);
        } else {
          this.banner = response && response.length > 0 ? response[0] : <Banner>{};
          const hideBannerInfo = response && response.length === 0;
          this.commonService.hideBanner.emit(hideBannerInfo);
        }
        if (this.banner.category != null && this.banner.category !== '') {
          this.showAlertIcon = true;
        }
        this.isSingleLine = (this.banner.bannerType && this.banner.bannerType === 'single') ? true : false;
      }
    });
  }

  expandBanner() {
    this.showShortDescription = !this.showShortDescription;
    this.getWidth();
    this.arrowIcon = this.showShortDescription ? 'open_in_full' : 'close_fullscreen';
  }

  closeBanner() {
    this.commonService.hideBanner.emit(true);
    this.storageService.setbannerCloseStatus(true);
  }

  ngAfterViewChecked() {
    const isCloseClicked = this.storageService.getBannerCloseStatus();
    if (isCloseClicked !== this.isCloseClicked) {
      this.isCloseClicked = isCloseClicked;
      this.cdRef.detectChanges();
    }
  }

  @HostListener('window:resize', ['$event'])
  getScreenSize(event?) {
    this.windowWidth = window.innerWidth;
  }
}

